/*
 * @Author: ken yang
 * @Date: 2022-09-01 09:10:19
 * @LastEditTime: 2023-07-18 10:50:09
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_admin/src/main.js
 */
import 'element-plus/dist/index.css'
import * as vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import 'default-passive-events'
import { createLanguage } from '@/language'
import * as ElIcons from '@element-plus/icons-vue'
import * as globalFunc from '@/utils/globalFunc/index.js'
import * as apis from '@/api/index.js'
import directives from '@/utils/directive/index.js'
import tableScroll from '@/utils/plugins/tableScroll.js'
import * as constant from '@/utils/constant.js'
import duration from 'dayjs/plugin/duration'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import vue3videoPlay from 'vue3-video-play' // 引入组件
import NP from 'number-precision'
import BigNumber from 'bignumber.js'
import 'vue3-video-play/dist/style.css' // 引入css
import 'uno.css'

const { winId, platform, token } = getUrlQuery()
if (token) localStorage.token = token

dayjs.extend(duration)

// import 'uno.css'
winMes.init()

window.addEventListener('resize', (e) => {
  eventBus.emit('onResize', e)
})

globalThis.winId = winId
globalThis.platform = platform ?? 'h5'
globalThis.$v = $v
globalThis.NP = NP
globalThis.BigNumber = BigNumber
let $t = null

const main = async (com, dom, options) => {
  $theme.init()
  const res = await createLanguage()
  if (!$t) {
    $t = res.$t
    globalThis.$t = $t
  }

  document.querySelector('html').setAttribute('version', import.meta.env.VITE_APP_VERSION)
  const app = import.meta.env.VITE_APP_IS_SSR ? vue.createSSRApp(App) : vue.createApp(com ?? App, options)
  const elIconsKeys = Object.keys(ElIcons)
  elIconsKeys.forEach(iconName => app.component(`Icon${iconName}`, ElIcons[iconName])
  )
  Object.keys(globalFunc).forEach(funcName => {
    app.config.globalProperties[funcName] = globalFunc[funcName]
  })
  Object.keys(constant).forEach(k => {
    app.config.globalProperties[k] = constant[k]
  })
  Object.keys(apis).forEach(k => {
    globalThis[k] = apis[k]
    app.config.globalProperties[k] = apis[k]
  })

  app.config.globalProperties.$t = $t
  app.config.globalProperties.$f = $f
  app.config.globalProperties.$v = $v
  app.config.globalProperties.$theme = $theme
  app.config.globalProperties.dayjs = dayjs
  app.config.globalProperties.winMes = winMes
  app.config.globalProperties.NP = NP
  app.config.globalProperties.BigNumber = BigNumber
  app.use(vue3videoPlay)
  app.use(VueViewer)
  app.use(directives)
  app.use(store)
  app.use(router)
  app.use(tableScroll)
  app.mount(dom ?? '#app')
  nextTick(() => {
    // inModule('/trade')
    idleInModuleList()
  })
  return { app, router }
}

main()

globalThis.BiCreateApp = async (com, dom, options) => {
  const { app, router } = await main(com, dom, options)
  return { app, router }
}

